<template>
    <div class="resumeOther resumeKeyword">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>简历关键词</h1>
                <p>{{keywordSize}}/5</p>
            </el-col>
            <el-col :span="20">
                <div class="workExpList" v-if="keywordSize > 0">
                    <div v-if="!resumeEditStatus" class="editBtn">
                        <!--编辑按钮-->
                        <el-button slot="reference" type="text" icon="el-icon-edit-outline"
                                   @click="editKeyword" v-has-permi="['resume:keyword:edit']"></el-button>

                    </div>

                    <div>
                        <!--编辑状态-->
                        <div v-if="editStatus.status==true">
                            <div v-if="resumeEditStatus==true && keywordEditStatus==true">
                                <resume-keyword-form :edit="form" :resumeId="resumeInfo.id"
                                                     :editStatus="editStatus"></resume-keyword-form>
                            </div>
                        </div>

                        <!--非编辑状态-->
                        <div v-else class="resumeContent">
                            <p class="rateDiv">
                                <el-tag style="margin: 0px 5px;" v-for="(item,index) in resumeInfo.keywordList" :key="item.id">{{item.labelName}}</el-tag>
                            </p>
                        </div>
                    </div>
                </div>

                <!--新增简历工作经历表单-->
                <div v-if="editStatus.status==false && resumeEditStatus==true && keywordEditStatus==true">
                    <resume-keyword-form :edit="form" :resumeId="resumeInfo.id" :editStatus="editStatus"
                                         @editStatus="getEditStatus"></resume-keyword-form>
                </div>
                <!--无简历关键词时新增-->
                <div v-if="keywordSize == 0 && editStatus.status==false && resumeEditStatus==false && keywordEditStatus==false"
                     class="addExp">
                    <el-button @click="add()" icon="el-icon-plus">添加关键词</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import ResumeKeywordForm from './Form/ResumeKeywordForm.vue';

    /**
     * 简历关键词
     */
    export default {
        name: 'ResumeKeyword',
        props: ['resumeInfo'],
        data() {
            return {
                // 表单编辑状态
                editStatus: {
                    status: false,
                },
                form: {
                    checkLabels: [] //选中评价标签
                },
            }
        },
        computed: {
            // 简历编辑状态
            resumeEditStatus() {
                return this.$store.state.index.resumeEditStatus;
            },
            // 简历关键词编辑状态
            keywordEditStatus() {
                return this.$store.state.index.resumeKeywordEditStatus;
            },
            // 简历关键词数量
            keywordSize() {
                return this.resumeInfo.keywordList.length;
            }
        },
        methods: {
            // 表单进入编辑状态
            editKeyword() {
                this.add();
                if (this.resumeInfo.keywordList) {
                    this.resumeInfo.keywordList.forEach(x => this.form.checkLabels.push(x.labelName));
                }
                this.editStatus.status = true;
            },
            // 简历关键词表单切换至编辑状态
            add() {
                this.form.checkLabels = []; //选中评价标签
                this.$store.commit('changeResumeEditStatus', true);
                this.$store.commit('changeResumeKeywordEditStatus', true);
            },
            /** 回调*/
            getEditStatus(data) {
                this.editStatus = data;
            }
        },
        components: {
            ResumeKeywordForm,
        }
    }
</script>
